<template>
  <div id="order-holder">

    <div v-if="!isLoading" class="webshop-cart-pages">
      <StepIndicator/>
      <router-view/>
    </div>

    <div class="order-holder-loading" v-bind:class="[ isLoading ? '' : 'hidden' ]">
      <div class="order-holder-loading-center">
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
      </div>
    </div>
  </div>
</template>

<style lang="less">

</style>

<script>
import StepIndicator from '@/components/StepIndicator.vue'
import { mapGetters } from "vuex";

export default {
  components: {
    StepIndicator
  },
  computed: {
    ...mapGetters({
      isLoading: 'getIsLoading'
    }),
  },
  mounted() {
    this.$store.dispatch('setDefaultData');
  },
}
</script>